export default "__VITE_ASSET__CVrgHmFM__"